import { ApiError } from '../../../shared/api/apiService';

export function getDocumentationErrorStatus(error: Error | null) {
  const isForbidden = error instanceof ApiError && error.status === 403;

  return {
    status: isForbidden ? '403' : '500',
    statusMessage: isForbidden ? 'Forbidden' : 'Something went wrong',
  };
}
